/** @jsx jsx */
import React, { type PropsWithChildren } from 'react';
import { css, jsx } from '@compiled/react';

export const ActionContainer = ({ children }: PropsWithChildren<{}>) => {
	return (
		<div
			data-testid="native-issue-table.common.ui.issue-cells.issue-key.action-container"
			css={containerStyles}
		>
			{children}
		</div>
	);
};

const containerStyles = css({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	'--copy-button-display': 'none',
	'&:hover': {
		'--copy-button-display': 'flex',
		'--copy-button-opacity': 1,
	},
	'&:focus-within': {
		'--copy-button-display': 'flex',
		'--copy-button-opacity': 1,
	},
});
